import { render, staticRenderFns } from "./ReferateGenerate.vue?vue&type=template&id=d5d4b6e0"
import script from "./ReferateGenerate.vue?vue&type=script&lang=js"
export * from "./ReferateGenerate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports